import { render, staticRenderFns } from "./EinstellungenCRM.vue?vue&type=template&id=056f8d67&"
import script from "./EinstellungenCRM.vue?vue&type=script&lang=js&"
export * from "./EinstellungenCRM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports